export enum ChipSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum ChipColors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  TEXT = 'text',
}

export enum ChipVariant {
  FILLED = 'filled',
  OUTLINED = 'outlined',
}
